import { WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import { RouteComponentProps } from "react-router";

import { KITS } from "../components";
import BoardingPass from "./BoardingPass";

type ClassNames = "container";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    container: {
    }
});

type BoardingProps = RouteComponentProps<{ id: string }>;

class Boarding extends React.Component<WithStyles<ClassNames> & BoardingProps> {
    public render() {
        const {match} = this.props;
        const {id} = match.params;
        const kit = KITS.filter(k => k.id === id)[0] || KITS[0];
        return (
            <BoardingPass {...{kit}} />
        );
    }
}

export default withStyles(styles)<BoardingProps>(Boarding);



// WEBPACK FOOTER //
// ./src/boarding/Boarding.tsx